export const EMPTY_TABLE_COLSPAN = 999;
